import { render, staticRenderFns } from "./InformacoesSociais.vue?vue&type=template&id=33afa81b&"
import script from "./InformacoesSociais.vue?vue&type=script&lang=js&"
export * from "./InformacoesSociais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports